/**
 * Libreria file delle newsletter: immagini da incorporare e allegati, caricati una volta
 * su S3 e riusabili in più newsletter e template.
 *
 * Ambito di visibilità: entità autorizzate NEWSLETTER e loro discendenti (lo decide il BE).
 */
import API from '../../api';

export const mediaApi = {
  /**
   * GET /newsletter-media — elenco paginato (24/pagina).
   * params: { page, type: 'image'|'document', q, entity_id }
   * La lista è SEMPRE paginata: i file possono essere migliaia.
   */
  list: (params) => API.get('/newsletter-media', { params }),

  /**
   * POST /newsletter-media — carica un file nella libreria di un'entità.
   * Se lo stesso contenuto è già presente il BE restituisce quello esistente (200 invece di 201),
   * quindi il file non viene duplicato né su S3 né in libreria.
   * NB: l'upload include una scansione antivirus e richiede una ventina di secondi.
   */
  upload: (entityId, file) => {
    const formData = new FormData();
    formData.append('entity_id', entityId);
    formData.append('file', file);

    return API.post('/newsletter-media', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  /** POST /newsletters/{id}/attachments/from-media — allega un file di libreria (nessun ricaricamento). */
  attachToNewsletter: (newsletterId, mediaId) =>
    API.post(`/newsletters/${newsletterId}/attachments/from-media`, { media_id: mediaId }),

  /** POST /newsletter-templates/{id}/attachments/from-media — idem per i template. */
  attachToTemplate: (templateId, mediaId) =>
    API.post(`/newsletter-templates/${templateId}/attachments/from-media`, { media_id: mediaId }),
};

export default mediaApi;
